import React, { useState } from 'react';
import { Visitor } from 'types/Visitor';
import { getStateFromValue } from 'assets/data/countriesAndStates';
import AGDatePicker from 'components/AGDatePicker/AGDatePicker';
import styles from './VisitorPlate.module.css';
import { useClickOutside } from 'hooks/useClickOutside';

type VisitorPlateProps = {
    visitor: Visitor;
    calendarMode: boolean;
    validateVisitor: (visitorPk: number, date?: Date) => void;
};

const today = new Date();

function VisitorPlate({
    visitor: { car_details: car, pk: visitorPk },
    calendarMode,
    validateVisitor,
}: VisitorPlateProps) {
    const [isShowingCalendar, toggleCalendar] = useState(false);
    const clickOutsideRef = useClickOutside(() => toggleCalendar(false));

    return (
        <div
            key={visitorPk}
            className={styles.plate}
            onClick={() => {
                calendarMode ? toggleCalendar(!isShowingCalendar) : validateVisitor(visitorPk);
            }}
            ref={clickOutsideRef}
        >
            <div className={styles.box}>
                <p>{getStateFromValue(car.state || '', car.country)?.label || 'AirGarage'}</p>
                <h1>{car.plate}</h1>
            </div>
            {isShowingCalendar && (
                <div className={styles.calendar} onClick={(event) => event.stopPropagation()}>
                    <AGDatePicker
                        setStartDate={(date) => date && validateVisitor(visitorPk, date)}
                        startDate={undefined}
                        earliestAvailableDate={today}
                    />
                </div>
            )}
        </div>
    );
}
export default VisitorPlate;
